"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Back4app2Error_1 = require("./Back4app2Error");
/**
 * Raised when a user tries to provision a NEW sandbox while already at the
 * `maxConcurrentRunningSandboxes` cap of their plan. Surfaces through the
 * GraphQL `formatError` hook with a stable code so the dashboard can render
 * a "you've reached the workspace limit; pause one to continue" prompt
 * instead of a generic 500.
 *
 * §4.11 / 1.1.10: this replaces the prior force-pause-oldest behavior in
 * `SandboxController.enforceConcurrentQuota`, which on the FREE plan
 * (limit = 1) was producing the resume-cascade documented in §7.6.
 */
var SandboxConcurrencyLimitError = /** @class */ (function (_super) {
    __extends(SandboxConcurrencyLimitError, _super);
    function SandboxConcurrencyLimitError(args) {
        var _this = _super.call(this, "user ".concat(args.userId, " has ").concat(args.currentCount, " concurrent running sandboxes; plan limit is ").concat(args.limit), SandboxConcurrencyLimitError.CODE) || this;
        _this.userId = args.userId;
        _this.currentCount = args.currentCount;
        _this.limit = args.limit;
        Object.setPrototypeOf(_this, SandboxConcurrencyLimitError.prototype);
        return _this;
    }
    SandboxConcurrencyLimitError.CODE = 'SANDBOX_CONCURRENCY_LIMIT_ERROR';
    return SandboxConcurrencyLimitError;
}(Back4app2Error_1.default));
exports.default = SandboxConcurrencyLimitError;
